import { render, staticRenderFns } from "./Manager.vue?vue&type=template&id=ddc5df20&"
import script from "./Manager.vue?vue&type=script&lang=ts&"
export * from "./Manager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports